<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @del="batchDel"
				ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Routing_Sequence_No" :label="$t('getapi[573]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WORKCENTER_NAME" :label="$t('getapi[585]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WORKPROC_NAME" :label="$t('getapi[2326]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WorkProc_Description" :label="$t('getapi[603]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[135]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="35%" :close-on-click-modal="false">
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
                <tr>
					<td>{{$t('getapi[573]')}}</td>
					<td><el-input v-model="dataList.routing_sequence_no" type="text" size="mini" class="mcolor"></el-input></td>
                    <td>{{$t('getapi[585]')}}</td>
					<td>
                        <routejump :urlNo="15" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="dataList.workcenter_name"
                                type="text"
                                readonly
                                size="mini"
                                class="mcolor"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectworkcenter"></i>
                        </el-input>
                        </routejump>
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[574]')}}</td>
                    <td>
                        <routejump :urlNo="14" :isDialog="1" @callback="beforeRoutJump">
                        <el-input v-model="dataList.workproc_name" type="text" readonly class="mcolor"
                                  size="mini">
                            <i class="el-icon-edit el-input__icon" slot="suffix"
                               @click="selectroute()"></i>
                        </el-input>
                        </routejump>
                    <td>{{$t('getapi[603]')}}</td>
                    <td><el-input v-model="dataList.workproc_description" type="text" size="mini" ></el-input></td>
                </tr>
			</table>
			</div>
			<el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading"
                           :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <!--工作中心-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetWorkCenterDataList'" @callback="getworkcenter" ref="workcenter"></selector>

        <!--工序-->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true" :postUrl="'/Pro/SO/GetSORoutingPopupDataList'"
                  @callback="getroute" ref="route"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
		name: 'prorepair',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                oldDataList :[],
                PageIndex: 1,
                PageSize: 50,
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: [],
                ids: "",
				btn: {
					del: false,
					edit: false
				},
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView();
			that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12794]"),this.$t("getapi[11]"));
            },
			//按钮操作权限
			authority() {
				let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
				//只读权
				if (that.$limits.ReadOnlyRights('plv2', 511, 1)) {
					that.$refs.SetBtn.SetButtonEnable('refresh');
				}
				//操作权
				let ilimits = that.$limits.UnOperationAuthority('plv2', 511, 1);
				// limits说明：、2 编辑权限、3 删除权限
				switch (ilimits) {
					case 2:
						that.btn.edit = true;
						that.btn.del = false;
						that.$refs.SetBtn.SetButtonEnable('create,save,refresh');
						break;
					case 3:
						that.btn.edit = true;
						that.btn.del = true;
						that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del');
						break;
					default:
                        that.$refs.SetBtn.SetButtonEnable('');
						break;
				}
			},
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.intidata();
				this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
				this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                console.log(row)
                let parm ={
                    Id:row.id
                }
                that.$http.urlpost('/Basic/Items/GetProRepairConfigById', parm, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent.Lines[0]){
                            let data = res.DataContent.Lines[0]
                            that.dataList = {
                                id: data.id,
                                routing_sequence_no: data.Routing_Sequence_No,
                                workcenter_code: data.WORKCENTER_CODE,
                                workcenter_name: data.WORKCENTER_NAME,
                                workproc_code: '',
                                workproc_name: data.WORKPROC_NAME,
                                workproc_id: data.WorkProc_Id,
                                workproc_description: data.WorkProc_Description,
                                create_time: data.Create_Time,
                                create_person: data.Create_Person,
                                modify_time: data.Modify_Time,
                                modify_person: data.Modify_Person
                            }
                            that.oldDataList = JSON.stringify(that.dataList)
                        }
                    }
                    that.isVisible = true
                });
            },
            // 获取数据
            getView() {
                let that = this;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        query_Condition: item.query_Condition,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.loading = true;
                that.$http.urlpost('/Basic/Items/ProRepairConfigDataList', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                let parm = new Array();
                parm = {
                    model:that.dataList
                }
                that.$http.urlpost('/Basic/Items/SaveProRepairConfig', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].id + ',';
                }
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                that.$http.urlpost('/Basic/Items/BatchDelProRepairConfig', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(row) {
                this.ids = row.row.id + ',';
                this.delf();
            },
            //批量删除
            batchDel() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisible = true;
                that.dataList = {
                    id: '',
                    routing_sequence_no: '',
                    workcenter_code: '',
                    workcenter_name:'',
                    workproc_name:'',
                    workproc_id: '',
                    workproc_description: '',
                    create_time: '',
                    create_person: '',
                    modify_time: '',
                    modify_person: ''
                }
            },
            // 刷新
            reflash() {
                this.getView();
            },
            exppostype(val) {
                if (val == '+') {
                    return this.$t('getapi[3484]')//'待入'
                } else if (val == '-') {
                    return this.$t('getapi[3485]')//待出'
                } else if (val == '*') {
                    return this.$t('getapi[2406]')//'普通'
                } else {
                    return ''
                }
            },
            expspflag(val) {
                if (val == 0) {
                    return this.$t('getapi[2406]')//'普通'
                } else if (val == 1) {
                    return this.$t('getapi[3472]')//'半成品区'
                } else if (val == 2) {
                    return this.$t('getapi[3473]')//'外协区'
                } else {
                    return ''
                }
            },
            //获取工作中心
            selectworkcenter() {
                let that = this;
                that.$refs.workcenter.clearInput(true);
            },
            getworkcenter(data) {
                let that = this
                console.log(data)
                that.dataList.workcenter_code = data.WORKCENTER_CODE
                that.dataList.workcenter_name = data.WORKCENTER_NAME
            },
            //获取工序
            selectroute() {
                let that = this;
                that.$refs.route.clearInput(true);
            },
            getroute(data) {
                let that = this;
                console.log(data);
                that.dataList.workproc_name = data.workproc_name;
                that.dataList.workproc_code = data.workproc_code;
                that.dataList.workproc_id = data.exclusively_id;
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataList != JSON.stringify(that.dataList)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
